
import React, { useState, useEffect } from "react";
import "./HomeSecondSec.css";
import {
    Typography,
    Button,
    Box,
    Grid,
    Dialog,
    DialogContent,
    TextField,
    MenuItem,
    InputLabel,
    Select,
    FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { FaCar, FaFileDownload, FaCogs } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa6";
import { hasSubmittedToday, markSubmittedToday, DUPLICATE_LEAD_MESSAGE } from "../../../Common/leadDedupe";
// import { kiaData } from './Data';
export const kiaData = {
    rightOptions: [
        {
            id: 1,
            title: "Book a Test Drive",
            icon: <FaCar />,
            bgColor: "#fff",
            color: "#000",
            type: "dialog",
        },
        {
            id: 2,
            title: "Get Quotations",
            icon: <FaQuoteRight />,
            bgColor: "#00111b",
            color: "#fff",
            type: "link",
            link: "/quotations",
        },
        {
            id: 3,
            title: "Book Service Appointment",
            icon: <FaCogs />,
            bgColor: "#00111b",
            color: "#fff",
            type: "dialog",
        },
        {
            id: 4,
            title: "Download Brochure",
            icon: <FaFileDownload />,
            bgColor: "#fff",
            color: "#000",
            type: "link",
            link: "/brochure",
        },
    ],
};
const KiaFestiveSection = ({ AddServiceForm, BookTestDrive, viewAddesByStatus, client }) => {
    // Detect mobile width
    const isMobile = window.innerWidth <= 1024;
    const [openDialog, setOpenDialog] = useState(null);
    const navigate = useNavigate();
    // const handleServiceOpen = () => setOpenServiceModal(true);
    // const handleServiceClose = () => setOpenServiceModal(false);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        modelType: "",
        carRegistrationNumber: "",
        preferredServiceCenterLocation: "",
        date: "",
    });
    const [formData1, setFormData1] = useState({
        name: "",
        email: "",
        mobile: "",
        modelType: "",
        date: "",
        address: "",
    });
    const [submittingService, setSubmittingService] = useState(false);
    const [submittingTestDrive, setSubmittingTestDrive] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFormData1((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleSubmitService = (e) => {
        e.preventDefault();
        if (submittingService) return;

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            alert("Please enter a valid email address.");
            return;
        }

        // Mobile validation (10 digits, numeric only)
        const mobileRegex = /^[0-9]{10}$/;
        if (!mobileRegex.test(formData.mobile)) {
            alert("Please enter a valid 10-digit mobile number.");
            return;
        }

        if (hasSubmittedToday(formData.mobile)) {
            alert(DUPLICATE_LEAD_MESSAGE);
            return;
        }

        setSubmittingService(true);
        AddServiceForm(
            formData.name,
            formData.email,
            formData.mobile,
            formData.modelType,
            formData.carRegistrationNumber,
            formData.preferredServiceCenterLocation,
            formData.date
        );
        markSubmittedToday(formData.mobile);

        // Reset formData to empty strings
        setFormData({
            name: "",
            email: "",
            mobile: "",
            modelType: "",
            carRegistrationNumber: "",
            preferredServiceCenterLocation: "",
            date: "",
        });
        // handleServiceClose();
        handleClose()
        setTimeout(() => setSubmittingService(false), 3500);
    };
    const handleSubmitTestDrive = (e) => {
        e.preventDefault();
        if (submittingTestDrive) return;
        // Perform validation or submit action here
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData1.email)) {
            alert("Please enter a valid email address.");
            return;
        }

        // Mobile validation (10 digits, numeric only)
        const mobileRegex = /^[0-9]{10}$/;
        if (!mobileRegex.test(formData1.mobile)) {
            alert("Please enter a valid 10-digit mobile number.");
            return;
        }

        if (hasSubmittedToday(formData1.mobile)) {
            alert(DUPLICATE_LEAD_MESSAGE);
            return;
        }

        setSubmittingTestDrive(true);
        BookTestDrive(
            formData1.name,
            formData1.email,
            formData1.mobile,
            formData1.modelType,
            formData1.date,
            formData1.address
        );
        markSubmittedToday(formData1.mobile);
        setFormData1({
            name: "",
            email: "",
            mobile: "",
            modelType: "",
            date: "",
            address: "",
        });
        // handleTestDriveClose();
        handleClose()
        setTimeout(() => setSubmittingTestDrive(false), 3500);
    };
    useEffect(() => {
        viewAddesByStatus();

    }, []);
    const handleClick = (item) => {
        if (item.type === "dialog") {
            setOpenDialog(item.id);
        } else if (item.type === "link") {
            // navigate to internal route
            navigate(item.link);
        } else if (item.type === "external") {
            // for external links (optional)
            window.open(item.link, "_blank");
        }
    };

    const handleClose = () => setOpenDialog(null);
    // Reorder for mobile
    const options = isMobile
        ? [
            kiaData.rightOptions[0], // Book a Test Drive
            kiaData.rightOptions[1], // Get a Question
            kiaData.rightOptions[2], // Download a Brochure
            kiaData.rightOptions[3], // Book a Service
        ]
        : kiaData.rightOptions;

    return (
        <div className="kia-outer">
            <h2 className="kia-heading">Start Your Kia Journey</h2>
            <div className="kia-section">
                <div className="kia-left">
                    {client?.addesByStatus?.mediaType === "image" ? (
                        <img src={client?.addesByStatus?.image} alt="Car" />
                    ) : (
                        <video
                            src={client?.addesByStatus?.image}
                            autoPlay
                            muted
                            loop
                            playsInline
                        />
                    )}
                </div>

                <div className="kia-right">
                    {options.map((item) => (
                        <div key={item.id}
                            onClick={() => handleClick(item)} className="kia-box">
                            <span className="kia-icon">{item.icon}</span>
                            <p>{item.title}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Dialog
                open={openDialog === 3} onClose={handleClose}
                maxWidth="md"
                fullWidth
                BackdropProps={{
                    style: {
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        backdropFilter: "blur(5px)",
                    },
                }}>
                <Box
                    sx={{
                        display: 'flex', justifyContent: 'flex-end'
                    }}
                    onClick={handleClose}>
                    <CloseIcon />
                </Box>

                <Box
                    sx={{
                        textAlign: 'center'
                    }}>
                    <Typography
                        sx={{
                            color: "#1a1a1a",
                            textAlign: "center",
                            fontSize: { md: "40px", xs: "20px", sm: "35px" },
                            fontFamily: "KIAbodyLatinbasic, Arial, sans-serif",
                            fontWeight: "bolder",
                        }}>
                        Service Appointment Form
                    </Typography>
                </Box>

                <DialogContent>
                    <form onSubmit={handleSubmitService}>
                        {/* Form Heading */}
                        <div style={{ textAlign: "center", marginBottom: "10px" }}>
                            <Typography
                                variant="body1"
                                className="KIAbodyLatinbasic_Regular"
                                sx={{
                                    fontSize: "12px",
                                    textAlign: "center",
                                    fontFamily: "KIAbodyLatinbasic_Regular",
                                }}
                            >
                                Please fill in the mandatory details for Service Appointment.
                            </Typography>
                        </div>

                        {/* Name and Email */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                marginBottom: "10px",
                            }}
                        >
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Name"
                                    name="name"
                                    fullWidth
                                    required
                                    value={formData.name}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                />
                            </div>

                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Email"
                                    name="email"
                                    type="email"
                                    fullWidth
                                    required
                                    value={formData.email}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                />
                            </div>
                        </div>

                        {/* Mobile and Model */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                marginBottom: "10px",
                            }}
                        >
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Mobile"
                                    name="mobile"
                                    type="number"
                                    fullWidth
                                    required
                                    value={formData.mobile}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                />
                            </div>

                            <div style={{ flex: "1 1 300px" }}>
                                <FormControl fullWidth margin="dense" required>
                                    <InputLabel
                                        sx={{
                                            "& .MuiInputLabel-asterisk": { color: "red" },
                                        }}
                                    >
                                        Model
                                    </InputLabel>
                                    <Select
                                        name="modelType"
                                        value={formData.modelType}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="seltos">Seltos</MenuItem>
                                        <MenuItem value="sonet">Sonet</MenuItem>
                                        <MenuItem value="carens">Carens</MenuItem>
                                        <MenuItem value="ev6">EV6</MenuItem>
                                        <MenuItem value="carnival">Carnival</MenuItem>
                                        <MenuItem value="ev9">EV9</MenuItem>
                                        <MenuItem value="syros">Syros</MenuItem>
                                        <MenuItem value="syros ev">Syros EV</MenuItem>
                                        <MenuItem value="sorento">Sorento</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>

                        {/* Car Registration and Service Center */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                marginBottom: "10px",
                            }}
                        >
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Car Registration Number"
                                    type="text"
                                    variant="standard"
                                    placeholder="e.g: OD39ZZ5697"
                                    name="carRegistrationNumber"
                                    value={formData.carRegistrationNumber}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "#d32f2f" } },
                                    }}
                                />
                            </div>

                            <div style={{ flex: "1 1 300px" }}>
                                <FormControl fullWidth required variant="standard">
                                    <InputLabel
                                        sx={{
                                            "& .MuiInputLabel-asterisk": { color: "#d32f2f" },
                                        }}
                                    >
                                        Preferred Service Center Location
                                    </InputLabel>
                                    <Select
                                        name="preferredServiceCenterLocation"
                                        value={formData.preferredServiceCenterLocation}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value="bbsr">Bhubaneswar</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>

                        {/* Preferred Date */}
                        <div style={{ marginBottom: "10px" }}>
                            <TextField
                                margin="dense"
                                label="Preferred Date for Service"
                                name="date"
                                type="datetime-local"
                                fullWidth
                                value={formData.date}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                    sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                }}
                                required
                            />
                        </div>

                        {/* Submit Button */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                marginTop: "10px",
                            }}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={submittingService}
                                sx={{
                                    backgroundColor: "#1a1a1a",
                                    fontWeight: "bolder",
                                    "&:hover": {
                                        backgroundColor: "#000000",
                                    },
                                }}
                            >
                                {submittingService ? "Submitting..." : "Submit"}
                            </Button>
                        </div>
                    </form>
                </DialogContent>

            </Dialog>
            {/* ------------------------------------------------------------------------------------------ */}
            {/* Test Drive */}
            <Dialog
                open={openDialog === 1} onClose={handleClose}
                maxWidth="md"
                fullWidth
                BackdropProps={{
                    style: {
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                        backdropFilter: "blur(5px)",
                    },
                }}>
                <Box
                    sx={{
                        display: 'flex', justifyContent: 'flex-end'
                    }}
                    onClick={handleClose}>
                    <CloseIcon />
                </Box>

                <Box
                    sx={{
                        textAlign: 'center'
                    }}>
                    <Typography
                        sx={{
                            color: "#1a1a1a",
                            textAlign: "center",
                            fontSize: { md: "40px", xs: "20px", sm: "35px" },
                            fontFamily: "KIAbodyLatinbasic, Arial, sans-serif",
                            fontWeight: "bolder",
                        }}>
                        Book a Test Drive
                    </Typography>
                </Box>


                <DialogContent>
                    <form onSubmit={handleSubmitTestDrive}>
                        {/* Heading */}
                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <Typography
                                variant="body1"
                                sx={{
                                    fontSize: "12px",
                                    textAlign: "center",
                                    fontWeight: 700,
                                    fontFamily: "KIAbodyLatinbasic_Regular",
                                }}
                            >
                                Please fill in the mandatory details for booking a Test Drive.
                            </Typography>
                        </div>

                        {/* Name & Email */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                marginBottom: "10px",
                            }}
                        >
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Name"
                                    name="name"
                                    fullWidth
                                    required
                                    value={formData1.name}
                                    onChange={handleChange1}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                />
                            </div>
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Email"
                                    name="email"
                                    type="email"
                                    fullWidth
                                    required
                                    value={formData1.email}
                                    onChange={handleChange1}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                />
                            </div>
                        </div>

                        {/* Mobile & Model Type */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                marginBottom: "10px",
                            }}
                        >
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Mobile"
                                    name="mobile"
                                    type="number"
                                    fullWidth
                                    required
                                    value={formData1.mobile}
                                    onChange={handleChange1}
                                    InputLabelProps={{
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                />
                            </div>
                            <div style={{ flex: "1 1 300px" }}>
                                <FormControl fullWidth margin="dense" required>
                                    <InputLabel
                                        sx={{
                                            "& .MuiInputLabel-asterisk": { color: "red" },
                                        }}
                                    >
                                        Model Type
                                    </InputLabel>
                                    <Select
                                        name="modelType"
                                        value={formData1.modelType}
                                        onChange={handleChange1}
                                    >
                                        <MenuItem value="seltos">Seltos</MenuItem>
                                        <MenuItem value="sonet">Sonet</MenuItem>
                                        <MenuItem value="carens">Carens</MenuItem>
                                        <MenuItem value="ev6">EV6</MenuItem>
                                        <MenuItem value="carnival">Carnival</MenuItem>
                                        <MenuItem value="ev9">EV9</MenuItem>
                                        <MenuItem value="syros">Syros</MenuItem>
                                        <MenuItem value="syros ev">Syros EV</MenuItem>
                                        <MenuItem value="sorento">Sorento</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>

                        {/* Date & Address */}
                        <div
                            style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "16px",
                                marginBottom: "10px",
                            }}
                        >
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Test Drive Date & Time"
                                    name="date"
                                    type="datetime-local"
                                    fullWidth
                                    value={formData1.date}
                                    onChange={handleChange1}
                                    InputLabelProps={{
                                        shrink: true,
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                    required
                                />
                            </div>
                            
                            <div style={{ flex: "1 1 300px" }}>
                                <TextField
                                    margin="dense"
                                    label="Address"
                                    name="address"
                                    type="text"
                                    fullWidth
                                    value={formData1.address}
                                    onChange={handleChange1}
                                    InputLabelProps={{
                                        shrink: true,
                                        sx: { "& .MuiInputLabel-asterisk": { color: "red" } },
                                    }}
                                    required
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                width: "100%",
                                marginTop: "10px",
                            }}
                        >
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={submittingTestDrive}
                                sx={{
                                    backgroundColor: "#1a1a1a",
                                    fontWeight: "bolder",
                                    "&:hover": {
                                        backgroundColor: "#000000",
                                    },
                                }}
                            >
                                {submittingTestDrive ? "Submitting..." : "Submit"}
                            </Button>
                        </div>
                    </form>
                </DialogContent>


            </Dialog>
        </div>
    );
};

export default KiaFestiveSection;
